import React from 'react'
import PropTypes from 'prop-types'
import { Container, Columns, Button, Logo, IconManager, deseretBookLogoPack, Text, Box, styled, Link } from '@deseretbook/react-ui'
import { usePopup } from '@deseretbook/react-utils'
import CartSidebar from '../header/CartSidebar'
import { withCheckout } from './CheckoutContext'


IconManager.register(deseretBookLogoPack)

const StyledNavbar = styled('header')(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
}))

/**
 * Navbar for checkout page.
 *
 * @returns {function} Component
 */
const CheckoutNavbar = ({ order }) => {
  const popup = usePopup()

  return (
    <StyledNavbar>
      <Container>
        {!!order && (
          <CartSidebar
            isReadOnly
            popupProps={popup.popupProps}
            orderNumber={order.number}
            orderToken={order.token}
            onClose={popup.close}
          />
        )}
        <Columns isMobile>
          <Columns.Column size={3}>
            <Box maxWidth={10} isFullheight isFullwidth justifyContent="center">
              <Link href="/">
                <Logo
                  name="deseretBook"
                  color="light"
                />
              </Link>
            </Box>
          </Columns.Column>
          <Columns.Column size={6}>
            <Text color="light" alignment="center" size="large" isBold hasEllipsis>
              Checkout
              {!!order && (
                <Text color="light"> ({order.totalQuantity} Item{(order.totalQuantity !== 1 && 's') || ''})</Text>
              )}
            </Text>
          </Columns.Column>
          <Columns.Column size={3}>
            <Box isFullwidth isFullheight alignItems="center" justifyContent="flex-end">
              <Button
                {...popup.triggerProps}
                disabled={!order}
                type="button"
                color="secondary"
                icon="shoppingCart"
              />
            </Box>
          </Columns.Column>
        </Columns>
      </Container>
    </StyledNavbar>
  )
}

CheckoutNavbar.propTypes = {
  order: PropTypes.shape({
    number: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    itemCount: PropTypes.number,
  }), // private
}

CheckoutNavbar.defaultProps = {
  order: {},
}

export default withCheckout(CheckoutNavbar)
